import { Home, MessageCircle, Search, User, type LucideIcon } from 'lucide-react';

export interface MainNavigationItem {
  to: string;
  icon: LucideIcon;
  label: string;
}

export function getMainNavigationItems(isDonor: boolean): MainNavigationItem[] {
  return [
    {
      to: '/dashboard',
      icon: Home,
      label: 'ホーム',
    },
    ...(isDonor
      ? []
      : [
          {
            to: '/search',
            icon: Search,
            label: '検索',
          },
        ]),
    {
      to: '/messages',
      icon: MessageCircle,
      label: 'メッセージ',
    },
    {
      to: '/mypage',
      icon: User,
      label: 'マイページ',
    },
  ];
}
